import { useTranslation } from 'react-i18next';
import { InvestmentType } from 'utils/proptypes';

type InvestmentNotesProps = { selectedInvestment?: InvestmentType; isFetching: boolean };

const InvestmentNotes = (props: InvestmentNotesProps) => {
  const { selectedInvestment, isFetching } = props;
  const [t] = useTranslation()
  return (
    <div className="collateral__container flex flex-col justify-start items-center mb-3">
      <h3 className="collateral__container--title uppercase w-full leading-none text-gray-900 text-base font-semibold text-start bg-yellow-100 p-4 rounded-t">
        {t('notes')}
      </h3>
      <div className="collateral__container--content w-full bg-yellow-50 rounded-b">
        <div className="w-full space-y-4 px-4 py-4 ">
          <p className="content-text leading-4 text-gray-900 text-sm font-normal">{!isFetching && selectedInvestment?.notes?.[0]?.content}</p>
        </div>
      </div>
    </div>
  );
};

export default InvestmentNotes;
